export const selectCurrencies = (state) => state.currencies.toList().toJS();

export const selectCurrencyBuId = ({ currencies }, currencyId) => {
  return currencies.find((currency) => currency.get('id') === currencyId) || currencies.first();
};
